import lightFormat from 'date-fns/lightFormat';

export const getLabelText = (freeDate: string | null, abGroup: string | null): string => {
  if (!freeDate) {
    return '';
  }

  const dateText = lightFormat(new Date(freeDate), 'dd.MM');

  if (abGroup === 'C') {
    return `Предложение действует до ${dateText}`;
  }

  return `Бесплатно до ${dateText}`;
};
